import React, { useEffect } from 'react';

import { AsDataGrid } from '@adserve/datagrid';
import { gridColumns } from './gridColumns';
import { useLiveContentDayReportContext } from './contexts/LiveContentDayReportContext';

const panelStyle = {
    height: 1,      // establish an absolute height value - the datagrid will fill the actual available height
    flexGrow: 1     // grow to fill the available space
};

export const InnerReportPanel = (props) => {

    return (
        <div style={panelStyle}>
            <AsDataGrid
                data={props.reportData}
                columns={gridColumns}
                isFetching={!props.reportData}
                downloadPdfButtonId={'liveContentDownload'}
                pdfFilename={props.pdfFilename}
            />
        </div>
    );
}

const CachedReportPanel = React.memo(InnerReportPanel);

export const ReportPanel = () => {
    const { reportData, pdfFilename, selectedLog, selectedDate, clearDownload, startHour, endHour } = useLiveContentDayReportContext();

    return <CachedReportPanel
        reportData={reportData?.filter((td)=>td.startTimeHrs >= startHour && td.startTimeHrs < endHour )}
        pdfFilename={pdfFilename}
        clearDownload={clearDownload}
        logName={selectedLog?.name}
        date={selectedDate}
    />;
};